module.exports = __webpack_public_path__ + "img/case2.1684621c.jpg";